module.exports = __webpack_public_path__ + "static/media/YB5F11_0.06495bd9.jpg";